import { lazy, FC, Suspense } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import { MenuTestPage } from '../pages/MenuTestPage'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../_metronic/helpers'
import { Timesheet } from '../../features/timesheet/Timesheet'
// import  BreakType  from '../../features/admin/breakType/BreakType'
import Project from '../../features/project/project/Project'
// import Task  from '../../features/project/task/Task'
import TaskList from '../../features/project/projectTask/TaskList'
// import CalendarView  from '../../features/project/task/CalendarView'
import GanttChart from '../../features/project/ganttChart/GanttChart'
import Employee from '../../features/admin/employee/Employee'
import { EmployeeSummary } from '../../features/admin/employee/EmployeeSummary'
import TimeOffRequest from '../../features/timeoffrequest/TimeOffRequest'
import TimesheetApproval from '../../features/approvals/timesheetapproval/TimesheetApproval'
import { TaskType } from '../../features/admin/taskType/TaskType'
import { ProjectType } from '../../features/admin/projectType/ProjectType'
import { EmployeeType } from '../../features/admin/employeeType/EmployeeType'
import { Status } from '../../features/admin/status/Status'
import { Priority } from '../../features/admin/priority/Priority'
import { TimeOffType } from '../../features/admin/timeOffTypes/TimeOffType'
import { ExpenseCategory } from '../../features/admin/expenseCategory/ExpenseCategory'
import { Currencies } from '../../features/admin/currencies/Currencies'
import { CurrencyExchangeRate } from '../../features/admin/currencyExchangeRates/CurrencyExchangeRate'
import ApiRecordLog from '../../features/admin/apiRecordLogs/ApiRecordLog'
import WebHookReceiverLog from '../../features/admin/webHookReceiverLogs/WebHookReceiverLog'
import WebHookReceiverLogsAudit from '../../features/admin/webHookReceiverLogsAudit/WebHookReceiverLogsAudit'
import { WebHook } from '../../features/admin/webhooks/WebHook'
import WebHookSenderLog from '../../features/admin/webHookSenderLogs/WebHookSenderLog'
import { ExternalUser } from '../../features/admin/externalUsers/ExternalUser'
import { EMailNotificationPreferences } from '../../features/admin/eMailNotificationPreferences/EMailNotificationPreferences'
import { TimeOffPolicy } from '../../features/admin/timeOffPolicies/TimeOffPolicies'
import TimeEntryArchive from '../../features/admin/timeEntryArchives/TimeEntryArchive'
import CustomField from '../../features/admin/customFields/CustomField'
import CustomFieldManage from '../../features/admin/customFields/CustomFieldManage'
import { Location } from '../../features/admin/location/Location'
import { TimesheetPeriodType } from '../../features/admin/timesheetPeriodTypes/TimesheetPeriodType'
import { AccountApproval } from '../../features/admin/accountApprovals/AccountApproval'
import { Integration } from '../../features/admin/integrations/Integration'
import { AccountQBOnline } from '../../features/admin/accountQBOnline/AccountQBOnline'
import { AccountZapierOnline } from '../../features/admin/accountZapierOnline/AccountZapierOnline'
import ExpenseEntryArchive from '../../features/admin/expenseEntryArchives/ExpenseEntryArchive'
import { AttachmentArchives } from '../../features/admin/attachmentArchives/AttachmentArchives'
import { ClientContact } from '../../features/admin/clientContacts/ClientContact'
import { ClientDepartment } from '../../features/admin/clientDepartment/ClientDepartment'
import { CustomReportView } from '../../features/report/customReportView/CustomReportView'
import { CustomReportDesign } from '../../features/report/customReportDesign/CustomReportDesign'
import CustomReportMain from '../../features/report/customReportDesign/CustomReportMain'
import { MyReports } from '../../features/report/myReports/MyReports'
import { AccountReportPermission } from '../../features/report/accountReportPermission/AccountReportPermission'
import { Attendance } from '../../features/attendance/Attendance'
import TimeOffApproval from '../../features/approvals/timeOffApproval/TimeOffApproval'
import { RolePermission } from '../../features/admin/rolePermissions/RolePermission'
import PaymentMethod from '../../features/admin/paymentmethod/PaymentMethod'
import TaxZone from '../../features/admin/taxZone/TaxZone'
import CostCenter from '../../features/admin/costCenter/CostCenter'
import HolidayType from '../../features/admin/holidayType/HolidayType'
import BillingType from '../../features/admin/billingType/BillingType'
import AbsenceType from '../../features/admin/absenceType/AbsenceType'
import HolidayTypeDetail from '../../features/admin/holidayTypeDetail/HolidayTypeDetail'
import ExpensePolicy from '../../features/admin/expensePolicy/ExpensePolicy'
import ExpensePolicyDetail from '../../features/admin/expensePolicyDetail/ExpensePolicyDetail'
import ExpensePolicyRule from '../../features/admin/expensePolicyRule/ExpensePolicyRule'
import ExpensePolicyPerDiem from '../../features/admin/expensePolicyPerDiem/ExpensePolicyPerDiem'
import ExpensePolicyLockingExpenses from '../../features/admin/expensePolicyLockingExpenses/ExpensePolicyLockingExpenses'
import AccountPreference from '../../features/admin/accountPreferences/AccountPreference'
import EmailNotificationPreference from '../../features/admin/emailNotificationPreference/EmailNotificationPreference'
import ManageTerminology from '../../features/admin/manageTerminology/ManageTerminology'
import FeatureManagement from '../../features/admin/featureManagement/FeatureManagement'
import PaidThrough from '../../features/admin/paidThrough/PaidThrough'
import AccountClient from '../../features/client/AccountClient'
import PayCode from '../../features/admin/payCode/PayCode'
import PayRule from '../../features/admin/payRule/PayRule'
import { AccountImportExport } from '../../features/admin/importExport/AccountImportExport'
import Expense from '../../features/expense/expenseSheet/ExpenseSheet'
import ExpenseSheet from '../../features/expense/expenseSheet/ExpenseSheet'
import ExpenseEntries from '../../features/expense/expenseEntries/ExpenseEntries'
// import  Department from '../../features/admin/Department/Department'
import Departments from '../../features/admin/departments/Departments'
import Role from '../../features/admin/role/Role'
import WorkType from '../../features/admin/worktype/WorkType'
import TaxCode from '../../features/admin/taxcode/TaxCode'
import ExpenseType from '../../features/admin/expensetype/ExpenseType'
import WorkingDayType from '../../features/admin/workingdaytypes/WorkingDayType'
import HolidaySelect from '../../features/admin/holidaySelect/HolidaySelect'
import TimesheetPeriodList from '../../features/timesheet/TimesheetPeriodList'
import ProjectTeam from '../../features/project/team/ProjectTeam'
import AccountProjectRole from '../../features/project/project/AccountProjectRole'
import AccountBillingRate from '../../features/billing/AccountBillingRate'
import AccountProjectSummary from '../../features/project/project/AccountProjectSummary'
import ProjectEmailNotificationPreferences from '../../features/project/emailNotification/ProjectEmailNotificationPreferences'
import AssignedProjectTeam from '../../features/project/team/AssignedProjectTeam'
import AccountProjectTaskSummary from '../../features/project/projectTask/AccountProjectTaskSummary'
import ProjectTaskTeam from '../../features/project/team/ProjectTaskTeam'
import AccountProjectTaskComments from '../../features/project/projectTask/AccountProjectTaskComments'
import { Shift } from '../../features/admin/shift/Shift'
import { Profile } from '../../features/profile/Profile'
import { Api } from '../../features/admin/api/API'
import { AccountDisableForm } from '../../features/admin/accountDisableForm/AccountDisableForm'
import { LicenseActivation } from '../../features/admin/licenseActivation/LicenseActivation'
import Break from '../../features/admin/break/break'
import { AccountPartySummary } from '../../features/client/AccountPartySummary'
import ExpenseApproval from '../../features/approvals/expenseApproval/ExpenseApproval'
import TaskRequestHours from '../../features/taskrequesthours/TaskRequestHours'
import TaskRequestApproval from '../../features/approvals/taskRequestHoursApproval/TaskRequestApproval'
import MyTask from '../../features/project/myTask/MyTask'
import Dashboard from '../../features/dashboard/Dashboard'
import AccountAudit from '../../features/audit/AccountAudit'
import ExpenseAudit from '../../features/audit/ExpenseAudit'
import TimesheetAudit from '../../features/audit/TimesheetAudit'
import ExpenseBillingWorksheet from '../../features/billing/expenseBillingWorkssheet/ExpenseBillingWorksheet'
import TimeBillingWorksheet from '../../features/billing/timeBillingWorkssheet/TimeBillingWorksheet'
import AccountTimeExpenseBilling from '../../features/billing/invoiceManagement/AccountTimeExpenseBilling'
import AccountInvoiceForm from '../../features/billing/invoiceManagement/AccountInvoiceForm'
import { InvoiceTemplate } from '../../features/admin/invoiceTemplate/InvoiceTemplate'
import EmployeeTimeOffAudit from '../../features/audit/EmployeeTimeOffAudit'
import QuickBookLog from '../../features/admin/accountQBOnline/accountQBLog/QuickBooksLog'
import TimesheetTemplate from '../../features/admin/timesheetTemplate/TimesheetTemplate'
import EmployeeEmailNotificationPreferences from '../../features/admin/employee/employeeEmailPreferences/EmployeeEmailNotificationPreferences'
import { EmployeeIntegrations } from '../../features/admin/employeeIntegrations/EmployeeIntegrations'
import MonthlyJournalReport from '../../features/report/customReportView/MonthlyJournalReport'
import LicenseActivationPage from '../../features/admin/licenseActivation/LicenseActivationPage'
import Packages from '../../features/admin/licenseActivation/Packages'
import Calendar from '../../features/calendar/calendar'
import SchedulerMain from '../../features/Scheduler/SchedulerMain'
import DashboardTemplate from '../../features/dashboard/dashboardTemplate'
import DashboardSummary from '../../features/dashboard/dashboardSummary'
import DashboardView from '../../features/dashboard/dashboardView'
import ScheduleReportAudit from '../../features/report/customReportView/ScheduleReportAudit'
import GeofencingZone from '../../features/admin/geofencingSetting/GeofencingZone'
import GeofencingMapApiForm from '../../features/admin/geofencingSetting/GeofencingMapApiForm'
import ProfileFormAndMap from '../../features/admin/geofencingSetting/ProfileFormAndMap'
import ZoneType from '../../features/admin/geofencingSetting/ZoneType'
import GeofenceZoneList from '../../features/admin/geofencingSetting/GeofenceZoneList'
import GeofenceProfileList from '../../features/admin/geofencingSetting/GeofenceProfileList'
import AttendanceList from '../../features/attendance/AttendanceList'
import AttendancePolicy from '../../features/admin/attendancePolicy/AttendancePolicy'
import AttendancePolicyList from '../../features/admin/attendancePolicy/AttendancePolicyList'
import BiometericDeviceConfiguration from '../../features/admin/BiometricDevice/BiometericDeviceConfiguration'
import BiometricConfigurationList from '../../features/admin/BiometricDevice/BiometricConfigurationList'
import ScheduleVSTackingHours from '../../features/Scheduler/ScheduleVSTackingHours'
import ExtensionContainer from '../../features/extension/ExtensionContainer'

// import TimesheetApprovedEmail from '../../features/approvals/timesheetapproval/TimesheetApprovedEmail'
// import {TimesheetApprovedEmail} from '../../app/modules/info/components/TimesheetApprovedEmail'


const PrivateRoutes = () => {
  //const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  //const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))
  const licenseExpireFlag = localStorage.getItem("IsLicenseExpired");
  const IsFreeLicenseExpired = localStorage.getItem("IsFreeLicenseExpired");
  
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        {/* by default timesheet page commet */}
        {/* <Route path='auth/*' element={<Navigate to='/timesheet' />} /> */}
        <Route path='auth/*' element={<Navigate to={(licenseExpireFlag === "true" || IsFreeLicenseExpired === "true") ? '/expiry' : '/dashboard'} />} />
        {/* <Route path="/dashboard" element={<Dashboard />} /> */}
        <Route path="/timesheet" element={<Timesheet />} />
        <Route path="/break" element={<Break />} />
        <Route path="/projects" element={<Project />} />
        <Route path="/accountprojecttemplates" element={<Project />} />
        <Route path='/calendar' element={<Calendar />} />
        {/* <Route path="/task" element={<Task />} /> */}
        <Route path="/task" element={<TaskList />} />
        <Route path="/ganttChart" element={<GanttChart />} />
        {/* <Route path="/calendar" element={<CalendarView />} /> */}
        <Route path="/paymentmethod" element={<PaymentMethod />} />
        <Route path="/costcenter" element={<CostCenter />} />
        <Route path="/holidaytype" element={<HolidayType />} />
        <Route path="/billingtype" element={<BillingType />} />
        <Route path="/schedule" element={<SchedulerMain />} />
        <Route path="/absencetype" element={<AbsenceType />} />
        <Route path="/taxzone" element={<TaxZone />} />
        <Route path="/holidaytypedetail/:AccountHolidayTypeId" element={<HolidayTypeDetail />} />
        <Route path="/expensepolicy" element={<ExpensePolicy />} />
        <Route path="/expensepolicydetail/:AccountExpensePolicyId" element={<ExpensePolicyDetail />} />
        <Route path="/expensePolicyRule" element={<ExpensePolicyRule />} />
        <Route path="/ExpensePolicyPerDiem" element={<ExpensePolicyPerDiem />} />
        <Route path="/ExpensePolicyLockingExpenses" element={<ExpensePolicyLockingExpenses />} />
        <Route path="/accountpreference" element={<AccountPreference />} />
        <Route path="/emailNotificationPreference" element={<EmailNotificationPreference />} />
        <Route path="/manageterminology" element={<ManageTerminology />} />
        <Route path="/featuremanagement" element={<FeatureManagement />} />
        <Route path="/paidThrough" element={<PaidThrough />} />
        <Route path="/client" element={<AccountClient />} />
        <Route path="/payCode" element={<PayCode />} />
        <Route path="/payRule" element={<PayRule />} />
        {/* <Route path="importexport" Component={() => {window.location.href = `${window.origin}/AccountAdmin/AccountImportExport.aspx`; return null }} /> */}
        <Route path="/importexport" element={<AccountImportExport />} />
        <Route path="/expense" element={<ExpenseSheet />} />
        <Route path="/expenseentries/:AccountEmployeeExpenseSheetId" element={<ExpenseEntries />} />
        {/* <Route path="/Department" element={<Department />} /> */}
        <Route path="/department" element={<Departments />} />
        <Route path="/role" element={<Role />} />
        <Route path="/worktype" element={<WorkType />} />
        <Route path="/taxcode" element={<TaxCode />} />
        <Route path="/ExpenseType" element={<ExpenseType />} />
        <Route path="/accountworkingday" element={<WorkingDayType />} />
        <Route path="/expensetype" element={<ExpenseType />} />
        <Route path="/workingdaytype" element={<WorkingDayType />} />
        {/* <Route path='dashboard' element={<DashboardWrapper />} />   */}
        {/* <Route path="dashboard" Component={() => {window.location.href = `${window.origin}/Employee/Default.aspx`; return null }} /> */}
        <Route path="timesheetPeriod" Component={() => { window.location.href = `${window.origin}/Employee/AccountEmployeeTimeEntryPeriodList.aspx`; return null }} />
        <Route path="expense" Component={() => { window.location.href = `${window.origin}/Employee/AccountExpenseEntry.aspx`; return null }} />
        <Route path="timeOff" Component={() => { window.location.href = `${window.origin}/Employee/MyTimeOff.aspx`; return null }} />
        {/* <Route path="attendance" Component={() => {window.location.href = `${window.origin}/Employee/MyAttendance.aspx`; return null }} /> */}
        {/* <Route path="employees" Component={() => {window.location.href = `${window.origin}/AccountAdmin/AccountEmployees.aspx`; return null }} /> */}
        {/* <Route path="clients" Component={() => {window.location.href = `${window.origin}/AccountAdmin/AccountParties.aspx`; return null }} /> */}
        {/* <Route path="projects" Component={() => {window.location.href = `${window.origin}/ProjectAdmin/AccountProjects.aspx`; return null }} /> */}
        <Route path="accounttimeexpensebilling" element={<AccountTimeExpenseBilling />} />
        {/* <Route path="billing" Component={() => {window.location.href = `${window.origin}/ProjectAdmin/TimeExpenseBillingMain.aspx`; return null }} /> */}
        {/* <Route path="reports" Component={() => {window.location.href = `${window.origin}/WebReport/MyReports.aspx`; return null }} /> */}
        <Route path="approvals" Component={() => { window.location.href = `${window.origin}/Employee/ManageApproval.aspx`; return null }} />
        {/* <Route path="adminPages" Component={() => {window.location.href = `${window.origin}/AccountAdmin/AdminMain.aspx`; return null }} />     */}
        <Route path='menu-test' element={<MenuTestPage />} />
        <Route path="/employee" element={<Employee />} />
        <Route path="/employeesummary/:AccountEmployeeId" element={<EmployeeSummary />} />
        <Route path="/timeoffrequest" element={<TimeOffRequest />} />
        <Route path="/timesheetapproval" element={<TimesheetApproval />} />
        <Route path="/tasktype" element={<TaskType />} />
        <Route path="/projecttype" element={<ProjectType />} />
        <Route path="/employeetype" element={<EmployeeType />} />``
        <Route path="/status" element={<Status />} />
        <Route path="/priority" element={<Priority />} />
        <Route path="/timeofftype" element={<TimeOffType />} />
        <Route path="/expensecategory" element={<ExpenseCategory />} />
        <Route path="/currencies" element={<Currencies />} />
        <Route path="/currencyexchangerates/:AccountCurrencyId" element={<CurrencyExchangeRate />} />
        <Route path="/apirecordlogs" element={<ApiRecordLog />} />
        {/* <Route path="/webHookReceiverLogs" element={<WebHookReceiverLog />} /> */}
        <Route path="/webhookreceiverlogs" element={<WebHookReceiverLog />} />
        <Route path="/webHookReceiverLogsAudit" element={<WebHookReceiverLogsAudit />} />
        <Route path="/webHooks" element={<WebHook />} />
        <Route path="/webHookSenderLogs" element={<WebHookSenderLog />} />
        <Route path="/externalusers" element={<ExternalUser />} />
        <Route path="/eMailNotificationPreferences" element={<EMailNotificationPreferences />} />
        <Route path="/timeoffpolicies" element={<TimeOffPolicy />} />
        <Route path="/timeentryarchives" element={<TimeEntryArchive />} />
        <Route path="/customfields" element={<CustomField />} />
        <Route path="/CustomFieldManage" element={<CustomFieldManage />} />
        <Route path="/location" element={<Location />} />
        <Route path="/timesheetperiodtypes" element={<TimesheetPeriodType />} />
        <Route path="/accountapprovals" element={<AccountApproval />} />
        <Route path="/integrations" element={<Integration />} />
        <Route path="/accountQBonline" element={<AccountQBOnline />} />
        <Route path="/accountzapieronline" element={<AccountZapierOnline />} />
        <Route path="/expenseentryarchives" element={<ExpenseEntryArchive />} />
        <Route path="/attachmentarchives" element={<AttachmentArchives />} />
        <Route path="/clientContacts" element={<ClientContact />} />
        <Route path="/clientDepartments" element={<ClientDepartment />} />
        <Route path="/customreportview/:AccountReportId" element={<CustomReportView />} />
        <Route path="/monthlyreportview/:AccountReportId" element={<MonthlyJournalReport />} />
        <Route path="/customreportdesign/:AccountReportId" element={<CustomReportMain />} />
        {/* <Route path="/MyReports" element={<MyReports />} /> */}
        <Route path="/myreports" element={<MyReports />} />
        <Route path="/AccountReportPermission/:AccountReportId" element={<AccountReportPermission />} />
        <Route path='/SchduleReportAudit' element={<ScheduleReportAudit />} />
        {/* <Route path="/attendance" element={<Attendance />} /> */}
        <Route path="/attendance" element={<AttendanceList />} />
        <Route path="/rolepermissions" element={<RolePermission />} />
        <Route path="/timeoffapproval" element={<TimeOffApproval />} />
        <Route path="/timesheetperiodlist" element={<TimesheetPeriodList />} />
        <Route path="/projectteam/:AccountProjectId" element={<ProjectTeam />} />
        <Route path="/accountprojectrole" element={<AccountProjectRole />} />
        <Route path="/holidayselect" element={<HolidaySelect />} />
        <Route path="/accountbillingrate/:AccountEmployeeId" element={<AccountBillingRate />} />
        <Route path="/accountprojectsummary/:AccountProjectId" element={<AccountProjectSummary />} />
        <Route path="/projectemailnotificationpreferences" element={<ProjectEmailNotificationPreferences />} />
        <Route path="/assignedprojectteam" element={<AssignedProjectTeam />} />
        <Route path="/accountprojecttasksummary/:AccountProjectId/:AccountProjectTaskId" element={<AccountProjectTaskSummary />} />
        <Route path="/projecttaskteam/:AccountProjectId/:AccountProjectTaskId" element={<ProjectTaskTeam />} />
        <Route path="/accountprojecttaskcomments" element={<AccountProjectTaskComments />} />
        <Route path="/shift" element={<Shift />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/api" element={<Api />} />
        <Route path="/accountdisableform" element={<AccountDisableForm />} />
        {/* <Route path="/licenseactivation" element={<LicenseActivation />} /> */}
        {/* <Route path="licenseactivation" element={<LicenseActivation />} /> */}
        <Route path='/expiry' element={<LicenseActivationPage />} />
        <Route path='/licenseactivation' element={<Packages />} />
        {/* <Route path="/AccountPartySummary" element={<AccountPartySummary />} /> */}
        <Route path="/accountpartysummary/:AccountClientId" element={<AccountPartySummary />} />
        <Route path="/expenseApproval" element={<ExpenseApproval />} />
        <Route path="/taskrequesthours" element={<TaskRequestHours />} />
        <Route path="/taskrequesthoursapproval" element={<TaskRequestApproval />} />
        <Route path="/mytasks" element={<MyTask />} />
        {/* <Route path="/dashboard" element={<Dashboard />} /> */}
        <Route path="/accountaudit/:AccountProjectId" element={<AccountAudit />} />
        <Route path="/expenseaudit/:AccountEmployeeExpenseSheetId" element={<ExpenseAudit />} />
        <Route path="/employeetimeoffaudit/:AccountEmployeeId" element={<EmployeeTimeOffAudit />} />
        <Route path="/timesheetaudit/:accountEmployeeTimeEntryPeriodId" element={<TimesheetAudit />} />
        <Route path="/expensebillingworksheet" element={<ExpenseBillingWorksheet />} />
        <Route path="/timebillingworksheet" element={<TimeBillingWorksheet />} />
        <Route path="/accountinvoiceform" element={<AccountInvoiceForm />} />
        <Route path="/invoicetemplate" element={<InvoiceTemplate />} />
        <Route path="/accountQBlog" element={<QuickBookLog />} />
        <Route path="/timesheettemplate" element={<TimesheetTemplate />} />
        <Route path="/employeeEmailPreferences" element={<EmployeeEmailNotificationPreferences />} />
        <Route path="/employeeIntegrations" element={<EmployeeIntegrations />} />
        <Route path="/dashboardTemplate" element={<DashboardTemplate />} />
        <Route path="/dashboardSummary" element={<DashboardSummary />} />
        <Route path="/dashboard" element={<DashboardView />} />
        <Route path="/dashboard/:id" element={<DashboardView />} />
        <Route path="/geofencing" element={<GeofencingZone />} />
        <Route path="/geofencing/:id/edit" element={<GeofencingZone />} />
        <Route path='/addGeofenceProfile' element={<ProfileFormAndMap/>}/>
        <Route path='/addGeofenceProfile/:id/edit' element={<ProfileFormAndMap/>}/>
        <Route path='/mapapi' element={<GeofencingMapApiForm/>}/>
        <Route path='/zoneType' element={<ZoneType/>}/>
        <Route path='/geofenceZone' element={<GeofenceZoneList/>}/>
        <Route path='/geofenceProfile' element={<GeofenceProfileList/>}/>
        {/* <Route path='/attendanceList' element={<AttendanceList/>}/> */}
        <Route path='/attendancePolicy/:AccountAttendancePolicyId' element={<AttendancePolicy/>}/>        
        <Route path='/attendancePolicy' element={<AttendancePolicy/>}/>
        <Route path='/attendancePolicyList' element={<AttendancePolicyList/>}/>
        <Route path='/biometericDeviceConfiguration' element={<BiometericDeviceConfiguration/>}/>
        <Route path='/biometericDeviceConfiguration/:id' element={<BiometericDeviceConfiguration/>}/>
        <Route path='/biometricConfigurationList' element={<BiometricConfigurationList/>}/>
        <Route path='/assignedScheduleHours' element={<ScheduleVSTackingHours/>}/>
        <Route path='/extensionPreview' element={<ExtensionContainer />} />
        
        
        {/* <Route path="/dashboardView/:AccountEmployeeDashboardsId" element={<DashboardView/>} /> */}
        {/* <Route path="/TimesheetApprovedEmail" element={<TimesheetApprovedEmail />} /> */}
        {/* <Route path="/info/TimesheetApprovedEmail" element={<TimesheetApprovedEmail />} /> */}



        {/* Lazy Modules */}
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              {/* <ChatPage /> */}
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              {/* <UsersPage /> */}
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        {/* <Route path='*' element={<Navigate to='/info' />} /> */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { PrivateRoutes }